import type {
  AnalyticsCampaignOption,
  AnalyticsCategoryOption,
  AnalyticsChannelOption,
} from "@/features/analytics/types";

const getUniqueItems = <T>({
  items,
  getKey,
}: {
  items: T[];
  getKey: (item: T) => string;
}): T[] => {
  const seen = new Set<string>();

  return items.filter((item) => {
    const key = getKey(item);

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);

    return true;
  });
};

export const getUniqueCampaigns = (
  campaigns: AnalyticsCampaignOption[],
): AnalyticsCampaignOption[] => {
  return getUniqueItems({
    items: campaigns,
    getKey: (campaign) => campaign.uuid,
  });
};

export const getUniqueChannels = (
  channels: AnalyticsChannelOption[],
): AnalyticsChannelOption[] => {
  return getUniqueItems({
    items: channels,
    getKey: (channel) => String(channel.id),
  });
};

export const getUniqueCategories = (
  categories: AnalyticsCategoryOption[],
): AnalyticsCategoryOption[] => {
  return getUniqueItems({
    items: categories,
    getKey: (category) => category.id,
  });
};
